export default __webpack_public_path__ + "static/media/bg-pattern-footer-desktop.700c39ea.svg";